import { render } from "./DebtsView.vue?vue&type=template&id=7c785805"
import script from "./DebtsView.vue?vue&type=script&lang=js"
export * from "./DebtsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__